module.exports = {
    DetailPane: require('./DetailPane')
};
